import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.commonApi';

export const commonApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.CONFIG],
	endpoints: {
		appConfigRetrieve: {
			providesTags: [EBaseApiTags.CONFIG],
		},
	},
});

export const { useAppConfigRetrieveQuery, useMetaRetrieveQuery } = commonApi;
